import { Spin } from 'antd';
import React from 'react';

export default function PageLoader({ loading }) {
	return <Spin fullscreen size="large" />;
}
